import { setJwtHeader } from 'lib/utils';
import { setAuthStep } from './generic';
import { handleCurrentSession, handleSignOut } from 'lib/utils/amplify';
import { config } from 'lib/utils/api';
import jwtDecode from 'jwt-decode';
import { setNewAccessToken, logout } from 'lib/actions';

type UserSignInData = {
    USERNAME: string;
    email: string;
    username: string;
};

export const endConsentSession = async () => {
    try {
        await handleSignOut();
    } catch {}
    setJwtHeader(null);
    localStorage.clear();
    sessionStorage.clear();
    setAuthStep(null);
};

export const getUserInfo = (): UserSignInData | null => {
    const storedUserInfo = localStorage.getItem('userInfo');

    if (storedUserInfo) {
        try {
            const userInfo: UserSignInData = JSON.parse(storedUserInfo);
            return userInfo;
        } catch (error) {
            console.error('Error parsing userInfo from local storage:', error);
        }
    }

    return null;
};

export const refreshToken = async dispatch => {
    try {
        const { accessToken } = await handleCurrentSession({
            forceRefresh: true,
        });
        const { isActive } = await jwtDecode(accessToken);

        if (!isActive) {
            throw new Error('User not active');
        }
        config.headers.Authorization = `Bearer ${accessToken}`;
        localStorage.setItem('accessToken', accessToken);
        await dispatch(setNewAccessToken({ token: accessToken }));
    } catch (error) {
        console.log({ error });
        await dispatch(logout());
    }
};
